import React, { Component, Fragment } from 'react';
import { ResponsiveContainer, BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Bar, LabelList } from 'recharts';
import { Card, CardHeader } from 'material-ui';

class SimpleBarChart extends Component {

    _renderTooltip(props) {
        const { active, payload, label } = props;
        if (!active) return null;
        return (
            <div className="custom-tooltip">
                <p className="label">{`${label}`}</p>
                <p style={{ color: payload[0].color }} className="label">{`Visitantes: ${payload[0].value}`}</p>
            </div>
        );
    }

    render() {
        const { data, dataKeyX, dataKeyY, typeX, typeY, height, maxHeight, minHeight, barColor } = this.props;
        let { vertical } = this.props;
        if (data.length * 50 > 400) vertical = true;
        return (
            <Fragment>
                {data.length > 0 ?
                    <ResponsiveContainer height={vertical ? 50 * data.length : height} maxHeight={maxHeight} minHeight={minHeight} id="graphic">
                        <BarChart data={data} layout={vertical ? 'vertical' : 'horizontal'}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis width={window.innerWidth * 0.7 * 0.9} type={vertical ? typeY : typeX} dataKey={vertical ? dataKeyY : dataKeyX} />
                            <YAxis width={window.innerWidth * 0.7 * 0.1} type={vertical ? typeX : typeY} dataKey={vertical ? dataKeyX : dataKeyY} />
                            <Tooltip content={this._renderTooltip} />
                            <Bar dataKey="personas" fill={barColor}>
                                <LabelList dataKey="personas" position={vertical ? 'right' : 'top'} />
                            </Bar>
                        </BarChart>
                    </ResponsiveContainer>
                    :
                    <Card style={{ textAlign: "center" }}>
                        <CardHeader title="Non hay resultados" />
                    </Card>
                }
            </Fragment>
        );
    }
}

export default SimpleBarChart;



// WEBPACK FOOTER //
// ./src/components/chartComponents/SimpleBarChart.js